module.exports = __webpack_public_path__ + "static/media/light-blue-women.a9ab81dc.png";